/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchPrivacyRequestsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {SearchPrivacyRequestsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const searchPrivacyRequests = (request:SearchPrivacyRequestsRequest, options?: CashRequestOptions) => post<SearchPrivacyRequestsRequest, SearchPrivacyRequestsResponse>("/2.0/cash/search-privacy-requests", request, {...options, rejectOnError: true })